import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { PrincipalLayouts } from "../../layouts"
import { fetchData } from '../helpers/getData/fetchData';
import { EventTable } from '../components/events/EventTable';
import { EventList } from '../components/events/EventList';

export const Events = () => {

  const { role } = useSelector(state => state.auth)
  const { t } = useTranslation('global')
  const [eventsList, setEventsList] = useState('isLoading');
  const [myEvents, setMyEvents] = useState('isLoading')
  const [reloadData, setReloadData] = useState(false)

  useEffect(() => {
    fetchData(setEventsList, '/events', t);
    fetchData(setMyEvents, '/eventRegister/myEvent', t);
  }, [reloadData, t])

  return (
    <PrincipalLayouts>
      {
        role === 'Admin' && eventsList !== 'isLoading' &&
        <EventTable rows={eventsList} setReloadData={setReloadData} />
      }
      {
        role !== 'Admin' && eventsList !== 'isLoading' && myEvents !== 'isLoading' &&
        <EventList rows={eventsList} myEvents={myEvents} setReloadData={setReloadData}/>
      }

      
    </PrincipalLayouts>
  )
}
